$(function () {
    $('.btn-toggle-menu').click(function (e) {

        $(this).toggleClass('active');

        $('.main-pc').slideToggle();
    });
});

jQuery(document).ready(function ($) {
    $('#menu-menu-principal > li').not(':last-child').each(function () {
        $('<span class="main-menu_sep"></span>').insertAfter($(this));
    });
});
